import { DataSourceEnum } from '@lunit-io/ctl-data-server';

/**
 * Determines whether API v3 should be used based on the provided data source.
 * Defaults to v2 when data source is unknown or not CC.
 */
export const shouldUseV3 = (dataSource?: DataSourceEnum | null): boolean => {
  if (!dataSource) return false;
  return dataSource === 'CASE_CURATOR';
};

export default shouldUseV3;
